import { Component, OnInit, ViewChild } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ToastService } from "ng-uikit-pro-standard";
import { DataService } from "src/app/data.service";
import { MatTableDataSource, MatSort, MatPaginator } from "@angular/material";
import { GUID } from "src/app/guid";
import { Router, ActivatedRoute } from "@angular/router";
import { AppConfig } from "src/app/config";

@Component({
  selector: "app-newaction",
  templateUrl: "./newaction.component.html",
  styleUrls: ["./newaction.component.scss"],
})
export class NewactionComponent implements OnInit {
  @ViewChild(MatSort, { static: false }) set mscontent(ms: MatSort) {
    this.matSort = ms;
  }
  matSort: MatSort;
  paginator: MatPaginator;
  guid: GUID;
  mode = "new";

  metaglobalaction: any;
  metaactionId: any;
  metaLayoutId: any;
  metaactionName: any;
  actionForm: FormGroup;
  metaobject: any;
  applicationId: any;
  isLoading = false;
  isError = false;
  metaobjectList = [];
  dataSource = new MatTableDataSource();
  name: any;
  errorMessage = "";
  metaobjectId = "";
  metaobjectName = "";
  parentObjects: any[]; // Make sure this is correctly populated with objects having 'objectid' and 'objectname' properties

  actionTypes = [
    { value: "create a record", label: "Create a Record" },
    { value: "send email", label: "Send email" },
    { value: "log a call", label: "Log a Call" },
    { value: "custom visualforce", label: "Custom Visualforce" },
    { value: "custom canvas", label: "Custom Canvas" },
    { value: "lightning component", label: "Lightning Component" },
    { value: "lightning web component", label: "Lightning Web Component" },
  ];

  standardLabels = [
    { value: "", label: "--None--" },
    { value: "Log a Call", label: "Log a Call" },
    { value: "Log a Note", label: "Log a Note" },
    { value: "New Record", label: "New Record" },
    { value: "Modify Service Appointment", label: "Modify Service Appointment" },
    { value: "Add Record", label: "Add Record" },
    { value: "Add Member", label: "Add Member" },
    { value: "New Document", label: "New Document" },
    { value: "Email", label: "Email" },
    { value: "Reply", label: "Reply" },
    { value: "Reply All", label: "Reply All" },
    { value: "Change Status", label: "Change Status" },


  ];



  constructor(
    private formBuilder: FormBuilder,
    private toastrService: ToastService,
    private dataService: DataService,
    private router: Router,
    private route: ActivatedRoute,
    private appConfig: AppConfig
  ) {
    this.actionForm = this.formBuilder.group({
      actiontype: ["create a record"],
      targetobject: [""],
      targetobjectid: [""],
      targetobjectname:"",
      standardlabel: [""],
      labelname: ["", Validators.required],
      name: ["", Validators.required],
      description: [""],
      createfeed: [false],
      successmessage: [""],
      iconname: [""],

    });
  }

  ngOnInit() {
    this.guid = new GUID();

    this.getActiveObjectsByType().then((res) => {
      console.log("response11111", res);
      console.log("parentobjects", this.parentObjects);
    });
    this.route.queryParams.subscribe((params) => {
      this.mode = this.route.snapshot.params.mode;
      // this.name = this.route.snapshot.params.name;
      this.metaactionId = this.route.snapshot.params.id;
      this.metaLayoutId = this.route.snapshot.params.metalayoutid;
      this.metaactionName = this.route.snapshot.params.name;

      console.log(this.mode);
      console.log(this.metaactionId);
      this.getGlobalActionById();
    });
    this.dataSource.sort = this.matSort;
    this.dataSource.paginator = this.paginator;
  }
  showWarning(data: any) {
    let options = {
      enableHtml: true,
      positionClass: "md-toast-bottom-right",
      messageClass: "orange darken-4",
      toastClass: "warning-color-dark",
    };
    this.toastrService.warning(data, "", options);
  }

  showSuccess(data: any) {
    let options = {
      enableHtml: true,
      positionClass: "md-toast-top-right",
      timeOut: 3000,
    };
    this.toastrService.success(data, "", options);
  }

  showError(data: any) {
    let options = { enableHtml: true, positionClass: "md-toast-bottom-right" };
    this.toastrService.error(data, "Application Error!", options);
  }



  getGlobalActionById() {
    let postOption = {
      organizationid: localStorage.getItem("crm_orgid"),
      userid: localStorage.getItem("crm_userid"),
      username: localStorage.getItem("crm_username"),
      // domain: localStorage.getItem("domain"),
      // subdomain: localStorage.getItem("subdomain"),
      domain: localStorage.getItem(`${localStorage.getItem("crm_orgid")}.domain`),
      subdomain: localStorage.getItem(`${localStorage.getItem("crm_orgid")}.subdomain`),
      data: {
        metaaction: {
          id: this.metaactionId,
        },
      },
    };
    console.log(this.metaactionId);
    this.isLoading = true;
    this.dataService.getMetaGlobalActionById(postOption).subscribe(
      (res) => {
        // alert('****res****' + JSON.stringify(res));
        console.log(res);
        if (res.success == 1) {
          this.metaglobalaction = res.data.MetaGlobalAction;
          console.log("Doneeee****", this.metaglobalaction);
          if (this.metaglobalaction != null) {
            this.metaLayoutId = this.metaglobalaction.metalayoutid;
            this.metaactionId = this.metaglobalaction.id;
            this.metaactionName = this.metaglobalaction.name;
            this.actionForm.controls["actiontype"].setValue(
              this.metaglobalaction.actiontype
            );
            this.actionForm.controls["targetobjectname"].setValue(
              this.metaglobalaction.targetobject
            );
            this.actionForm.controls["targetobjectid"].setValue(
              this.metaglobalaction.targetobjectid
            );
            this.actionForm.controls.targetobject.patchValue(
              this.metaglobalaction.targetobjectid
            );
            this.actionForm.controls["standardlabel"].setValue(
              this.metaglobalaction.standardlabeltype
            );
            this.actionForm.controls["labelname"].setValue(
              this.metaglobalaction.labelname
            );
            this.actionForm.controls["name"].setValue(
              this.metaglobalaction.name
            );
            this.actionForm.controls["description"].setValue(
              this.metaglobalaction.description
            );
            this.actionForm.controls["createfeed"].setValue(
              this.metaglobalaction.createfeeditem
            );
            this.actionForm.controls["successmessage"].setValue(
              this.metaglobalaction.successmessage
            );
            this.actionForm.controls["iconname"].setValue(
              this.metaglobalaction.iconname
            );
          }

          this.isLoading = false;
        } else {
          console.log("no data");
          this.isLoading = false;
          //this.resetDetailFormControls();
        }
      },
      (err) => {
        console.log("Error***:", err);
        this.errorMessage = err.message;
        this.isError = true;
        this.isLoading = false;
        //this.resetDetailFormControls();
      }
    );
  }

  // parentObjectChange(event: any) {
  //   console.log(event);
  //   console.log(event.target.value);
  //   const selectedid = event.target.value;
  //   const selectedname = event.target.options[event.target.selectedIndex].text;
  //   // const selectedname = event.target.text;

  //   this.actionForm.controls["targetobjectid"].setValue(selectedid);
  //   this.actionForm.controls["targetobject"].setValue(selectedname);
  // }

  parentObjectChange(event: { value: string; label: any }) {
    console.log("parentObjectChange", event);
    if (event.value.trim() != "") {
      this.actionForm.controls["targetobjectid"].setValue(event.value);
      this.actionForm.controls["targetobjectname"].setValue(event.label);
      console.log(this.actionForm.controls)
    } else {
      this.actionForm.controls["targetobjectid"].setValue("");
      this.actionForm.controls["targetobjectname"].setValue("");
    }
  }

  getActiveObjectsByType() {
    return new Promise((resolve, reject) => {
      console.log("getActiveObjectsByType");

      let postOption = {
        organizationid: localStorage.getItem("crm_orgid"),
        userid: localStorage.getItem("crm_userid"),
        username: localStorage.getItem("crm_username"),
        // domain: localStorage.getItem("domain"),
        // subdomain: localStorage.getItem("subdomain"),
        domain: localStorage.getItem(`${localStorage.getItem("crm_orgid")}.domain`),
        subdomain: localStorage.getItem(`${localStorage.getItem("crm_orgid")}.subdomain`),
        data: {
          metaobject: {
            objecttype: "Domain",
          },
        },
      };
      console.log("postOption", postOption);
      this.isLoading = true;
      this.dataService.getActiveObjectsByType(postOption).subscribe(
        (res) => {
          console.log(res);
          if (res !== null && res.success == 1) {
            var activeObjects = res.data.metaobjects;
            var objArr = [];
            //just add an empty entry sice this field is optional
            objArr.push({ value: "", label: "--None--" });
            for (let i = 0; i < activeObjects.length; i++) {
              objArr.push({
                // objectid: activeObjects[i].id,
                // objectname: activeObjects[i].name,
                value: activeObjects[i].id,
                label: activeObjects[i].name,
              });
            }
            this.parentObjects = objArr;

            this.isLoading = false;
            resolve(null);
          } else {
            console.log("No metaobject data!");
            this.errorMessage =
              res != null ? res.message : "No metaobject data!";
            this.isError = true;
            this.isLoading = false;
            resolve(null);
          }
        },
        (err) => {
          console.log("Error***:", err);
          this.errorMessage = err.message;
          this.isError = true;
          this.isLoading = false;
          resolve(null);
        }
      );
    });
  }

  cancel() {
    this.router.navigateByUrl("home/globalaction");
  }

  save() {
    // if (this.actionForm.invalid) {
    //   this.showWarning("Please fill in all required fields");
    //   return;
    // }

    if (this.actionForm.controls["labelname"].value.toString().trim() == "") {
      this.showWarning("Action label is mandatory");
      return;
    }
    if (this.actionForm.controls["name"].value.toString().trim() == "") {
      this.showWarning("Action name is mandatory");
      return;
    }
    if (this.actionForm.controls["targetobjectid"].value.toString().trim() == "") {
      this.showWarning("Action target object is mandatory");
      return;
    }
    if (this.actionForm.controls["standardlabel"].value.toString().trim() == "") {
      this.showWarning("Action Standard label is mandatory");
      return;
    }
    
    // if (this.actionForm.valid) {
      console.log("actionForm", this.actionForm);
      // const formData = this.actionForm.value;
      console.log("actionForm", this.mode);

      if (this.mode == "new") {
        this.metaactionId = this.guid.getGUID("metaglobalaction");
        this.metaLayoutId = this.guid.getGUID("metalayout");
      }
      let postOption = {
        organizationid: localStorage.getItem("crm_orgid"),
        domain: localStorage.getItem(`${localStorage.getItem("crm_orgid")}.domain`),
        subdomain: localStorage.getItem(`${localStorage.getItem("crm_orgid")}.subdomain`),
        userid: localStorage.getItem("crm_userid"),
        username: localStorage.getItem("crm_username"),
        useralias: localStorage.getItem("crm_useralias"),
        data: {
          metaaction: {
            // id: this.guid.getGUID("metaglobalaction"),
            id: this.metaactionId,
            metalayoutid: this.metaLayoutId,
            mode: this.mode,
            actiontype: this.actionForm.controls["actiontype"].value,
            targetobject: this.actionForm.controls["targetobjectname"].value,
            targetobjectid: this.actionForm.controls["targetobjectid"].value,
            standardlabeltype: this.actionForm.controls["standardlabel"].value,
            labelname: this.actionForm.controls["labelname"].value,
            name: this.actionForm.controls["name"].value,
            description: this.actionForm.controls["description"].value,
            createfeeditem: this.actionForm.controls["createfeed"].value,
            successmessage: this.actionForm.controls["successmessage"].value,
            iconname: this.actionForm.controls["iconname"].value,

            active: true,
            content: "Action Layout Editor",
          },
        },
      };
      // console.log("formData",formData);
      console.log("postOption", postOption);

      // alert(formData)
      this.dataService.upsertMetaglobalaction(postOption).subscribe(
        (res) => {
          //alert('****res****' + JSON.stringify(res));
          console.log(res);
          if (res.success == 1) {
            this.showSuccess(res.message);
            this.isLoading = false;
            this.router.navigateByUrl("/home/globalaction");
          } else {
            console.log("error while saving");
            this.showError(res.message);
            this.isLoading = false;
          }
        },
        (err) => {
          console.log("Error***:", err);
          this.showError(err.message);
          this.isError = true;
          this.isLoading = false;
        }
      );
      console.log("URL:", this.appConfig.config.ipaddress);
    // }
  }
}
